import * as React from "react";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import EmailIcon from "@material-ui/icons/Email";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import CallIcon from "@material-ui/icons/Call";
import CreateIcon from "@material-ui/icons/Create";
// import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";


const FloatButton = () => {
  
    const actions = [
      //{ icon: <FormatListBulletedIcon />, name: "Recensioni" ,href:"#"},
      { icon: <EmailIcon />, name: "Email" ,action: (e) => {
          e.preventDefault();
          window.location.href='mailto:info@manutenpul.it';
        }
      }, 
      { icon: <WhatsAppIcon />, name: "WhatsApp" ,action: (e) => {
          e.preventDefault();
          window.location.href="https://api.whatsapp.com/send/?phone=+393917417882&text=Sono+interessato+a+un+servizio&app_absent=0";
        }
      },
      { icon: <CallIcon />, name: "Chiamaci" ,
      action: (e) => {
        e.preventDefault();
        window.location.href="tel:+39.02.31055156";
      }
    },
      { icon: <CreateIcon />, name: "Richiedi Preventivo" ,action: (e) => {
        e.preventDefault();
        window.location.href="/contact";
      }
    }, 
    ];
  
    const [open, setOpen] = React.useState(false);
  
    const handleClose = () => {
      setOpen(false);
    };
  
    const handleOpen = () => {
      setOpen(true);
    };
  
    return (
      <SpeedDial
        ariaLabel="SpeedDial example"
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction="up"
        style={{
          'position': 'fixed',
          'bottom': '5px',
          'right': '5px',
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={action.action}
          />
        ))}
      </SpeedDial>
    );
  }

  export default FloatButton;